
import { useNavigate } from "react-router-dom";
import { FaArrowRight, FaArrowRightLong } from "react-icons/fa6";
import Colors from "../../utils/colors";


function HeaderUseCaseList(){
let navigate = useNavigate();
return(
<div>
<div className="dropdown-menu-h" style={{borderColor:Colors.bg2}}>
                <div className="row no-margin">
                    <div className="col-md-4 no-padding">
                        <div style={{width:"100%", height:"100%", padding:"3em 2.5em", backgroundColor:Colors.bg2}}>
                            <div className="bold h2" style={{paddingBottom:"1em"}}>Industries</div>
                            <div style={{color:Colors.black1, fontSize:"17px", lineHeight:1.6}}>
                                Finance Teams across different industries use MonyTrack Business to simplify their financial operations. 
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 no-padding">
                        <div style={{width:"100%", padding:"3em 2.5em", }}>
                            <div style={{color:Colors.gray, fontSize:"14px", marginBottom:'1em'}}>INDUSTRIES</div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/use-cases/finance-teams")}>
                                <div className="dot"></div> <div className="m-item">Finance Teams</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/use-cases/marketing")}>
                                <div className="dot"></div> <div className="m-item">Marketing</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/use-cases/startups")}>
                                <div className="dot"></div> <div className="m-item">Startups</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/use-cases/healthcare")}>
                                <div className="dot"></div> <div className="m-item">Healthcare</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/use-cases/pharmaceuticals")}>
                                <div className="dot"></div> <div className="m-item">Pharmaceuticals</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/use-cases/nonprofits")}>
                                <div className="dot"></div> <div className="m-item">Nonprofits</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                             
                        </div>
                    </div>
                    <div className="col-md-4 no-padding">
                        <div style={{width:"100%", padding:"3em 2.5em", }}>
                            <div style={{color:Colors.gray, fontSize:"14px", marginBottom:'1em'}}>.</div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/use-cases/fmcgs")}>
                                <div className="dot"></div> <div className="m-item">FMCGs</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/use-cases/restaurants")}>
                                <div className="dot"></div> <div className="m-item">Restaurants</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/use-cases/manufacturing")}>
                                <div className="dot"></div> <div className="m-item">Manufacturing</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/use-cases/logistics")}>
                                <div className="dot"></div> <div className="m-item">Logistics & Transportation</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
</div>
)
}
export default HeaderUseCaseList;